import { StreamProvider } from '@shared/types/room';

import CloudflareCalls from '../providers/cloudflareCalls';
import CloudflareStreaming from '../providers/cloudflareStreaming';
import IvsRealTime from '../providers/ivsRealtime';
import Stripchat from '../providers/stripchat';

const providers = {
    [StreamProvider.CloudFlare]: CloudflareStreaming,
    [StreamProvider.CloudFlareCalls]: CloudflareCalls,
    [StreamProvider.StripChat]: Stripchat,
    [StreamProvider.IvsRealTime]: IvsRealTime,
    [StreamProvider.Unknown]: null,
    [StreamProvider.None]: null,
};
export default class ProvidersFactory {
    create(type: StreamProvider) {
        if (!providers[type]) {
            return null;
        }
        // eslint-disable-next-line
        // @ts-ignore
        return new providers[type]();
    }
}